<template>
  <div>
    <v-list flat dense>
      <draggable v-model="serviceTypes" @start="startTouch" @end="endTouch" handle=".draggable-area" ghost-class="ghost" ref="draggableComponent">
        <div v-for="(serviceType) in serviceTypes" v-bind:key="serviceType.id">
          <v-list-item>
            <v-list-item-avatar>
              <v-icon small class="draggable-area mx-2 mr-4">mdi-menu</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div>
                <v-container v-if="!editing || editService.id != serviceType.id" fluid class="pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col class="pa-0">
                      {{serviceType.name}}
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </div>
      </draggable>
    </v-list>

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import DurationPicker from '@/components/common/DurationPicker.vue'
import StandardDialog from '@/components/common/StandardDialog.vue'
import dateUtils from '@/mixins/common/dateUtils.js'
import serviceTypesCategoriesService from '@/services/serviceTypesCategories/serviceTypesCategories.service'

export default {
  name: "OrderFamilyForm",
  mixins: [dateUtils],
  components: {
    draggable,
    DurationPicker,
    StandardDialog
  },
  data: function() {
    return {
      serviceTypes: [],
      drag: false,
      editService: undefined,
      createService: {},
      newServiceDialog: false,
      editValid: false,
      createValid: false,
      presenceRule: (v) => {
        return !!v || 'Il campo è obbligatorio'
      },
      oldServiceTypes: undefined
    }
  },
  props: {
    id:{
    },
    generateIdWhenCreate: {
      type: Boolean,
      default: false
    },
    bus:{
      default: function() {
        return new Vue()
      }
    }
  },
  mounted: async function() {
    this.bus.$on('changeOrder', this.changeOrder)
    this.bus.$on('closeOrder', this.closeOrder)
    await serviceTypesCategoriesService.getServiceTypes(this.id).then(res => {
      this.serviceTypes = res[0].serviceTypes
    })
    let counter = 0
    this.serviceTypes.forEach(elem => {
      elem.order = counter
      counter++
    })
    this.oldServiceTypes = this.serviceTypes
  },
  methods: {
    edit(service) {
      this.editService = {...service}
    },
    submitCreate() {
      if(!this.createService.minutes){
        alert('Inserire una durata')
      } else {
      if(this.generateIdWhenCreate) {
        let id = this.getUniqId()
        this.services.push({id: id, ...this.createService})
      } else {
        this.services.push({...this.createService})
      }

      this.$emit('create-phase', this.createService)
      this.newServiceDialog = false
      this.createService = {}
      this.$refs.newForm.resetValidation()
      this.$emit('input', this.services)
      }
    },
    submitEdit() {
      let index;
      for(var i = 0; i < this.services.length; i++) {
        if(this.services[i].id == this.editService.id) {
          index = i
        }
      }
      if(index != undefined) {
        this.services[index] = Object.assign({}, this.services[index], this.editService)
        this.$emit('update-phase', this.editService)
        this.$emit('input', this.services)
      }
      this.editService = undefined
    },
    getUniqId() {
      let max = 0;
      for(let i = 0; i < this.services.length; i++) {
        if(max == undefined || parseInt(this.services[i].id) > max) {
          max = parseInt(this.services[i].id)
        }
      }
      return max + 1
    },
    startTouch() {
      this.drag = true
    },
    endTouch(context) {
      this.drag = false
      // this.$emit('input', this.services)
      // this.$emit('move-phase', this.services[context.newIndex], context.newIndex)
    },
    changeOrder(){
      let counter = 0
      this.serviceTypes.forEach(elem => {
        elem.order = counter
        counter++
      })
      
      this.oldServiceTypes = this.serviceTypes

      let mapped = this.serviceTypes.map(elem => {return {id: elem.id, order: elem.order}})
      serviceTypesCategoriesService.updateOrderServiceTypes(mapped)
    },
    closeOrder(){
      this.serviceTypes = this.oldServiceTypes
    }
  },
  computed: {
    editing() {
      return !!this.editService
    }
  },
  watch: {
    value(newValue) {
      this.services = newValue
    }
  }
}
</script>

<style>

.draggable-area {
	cursor: move
}

.ghost {
	background-color: #b6b6b6;
	opacity: 0.2;
}

</style>